import {Injectable} from '@angular/core';
import {Resolve, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {Appointment} from "../shared/models/appointment";
import {DataStoreService} from "../shared/services/api/data-store.service";

@Injectable()
export class AppointmentResolverService implements Resolve<Appointment> {
  constructor(private dataStore: DataStoreService,
              private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {

    let id = route.params['id'];
    if (id) {
      let appointment = this.dataStore.peekRecord(Appointment, id);
      if (appointment) {
        return appointment;
      } else {
        return this.dataStore.findRecord(Appointment, id);
      }
    } else {
      return true;
    }

  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/appointment/appointment-resolver.service.ts